import { React, useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";
import { useParams } from "react-router";

import { Button, LinkButton } from "../../commonComponents/Buttons";
import { QuatroGrid } from "../../commonComponents/Grids";

import challengesService from "../../../services/challengesService";
import {
  get_challenge_list,
  get_more_challenge_list,
} from "../../../redux/features/challengeSlice";

import "./challenges.scss";
import {
  CoinIcon,
  VideoViewsIcon,
  LikedIcon,
  UnlikedIcon,
} from "../../../assets";

function ChallengesList() {
  const { t } = useTranslation();
  const params = useParams();
  const challengesListInfo = useSelector(
    (state) => state?.challenges?.challengesList
  );
  const dispatch = useDispatch();

  const [challengesList, setChallengesList] = useState();

  useEffect(() => {
    if (!challengesList) {
        dispatch(get_challenge_list(params.categoryId)).then((result) =>
          setChallengesList(result?.payload?.results)
        );
    }
  }, [challengesList, params, dispatch]);

  function likeHandler(challengeId) {
    challengesService
      .addChallengeLike(params.categoryId, challengeId)
      .then((result) => {
        let tempArray = [...challengesList];
        const index = challengesList.findIndex(
          (item) => item?.id === challengeId
        );
        tempArray[index] = {
          ...tempArray[index],
          liked: result?.data?.result?.liked,
          likes: result?.data?.result?.likes,
        };

        setChallengesList(tempArray);
      });
  }

  function loadMore() {
    dispatch(get_more_challenge_list(challengesListInfo.next)).then(
      (result) => {
        setChallengesList(challengesList.concat(result?.payload?.results));
      }
    );
  }

  return (
    <main>
      <LinkButton
        label={t("back")}
        iconClassName="hasIcon--chevron-left"
        viewType="backButton"
        goTo="/challenges-categories"
      />
      <QuatroGrid
        title={challengesListInfo?.title}
        viewType="wide"
        ifPagination={challengesListInfo?.next ? true : false}
        paginationClick={loadMore}
      >
        {challengesList &&
          challengesList?.map((item) => {
            return (
              <li key={item?.id}>
                <div to="/challenge/video" className="challengeCard">
                  <NavLink
                    to={`/challenge/${params.categoryId}/video/${item?.id}`}
                    className="challengeLink"
                  >
                    {item?.new_challenge && (
                      <div className="newLabel">{t("newChallenge")}</div>
                    )}
                    <img
                      className="challengeImage"
                      src={item?.cover_image}
                      alt={t("challenge")}
                    />
                  </NavLink>
                  <p className="challengeTitle">{item?.title}</p>
                  <div className="infoBlock">
                    <div className="leftBlock">
                      <div className="activityCounter">
                        <img
                          className="activityIcon"
                          src={VideoViewsIcon}
                          alt={t("views")}
                        />
                        <p className="activityTxt">{item?.views}</p>
                      </div>
                      <div className="activityCounter">
                        <Button
                          viewType="clildrenBtn"
                          onClick={() => likeHandler(item?.id)}
                        >
                          <img
                            className="activityIcon"
                            src={item?.liked ? LikedIcon : UnlikedIcon}
                            alt={t("likes")}
                          />
                        </Button>
                        <p className="activityTxt">{item?.likes}</p>
                      </div>
                    </div>
                    <div className="activityCounter">
                      <img
                        className="activityIcon"
                        src={CoinIcon}
                        alt={t("points")}
                      />
                      <p className="activityTxt">
                        {item?.earned_points}
                        <span>/2</span>
                      </p>
                    </div>
                  </div>
                </div>
              </li>
            );
          })}
      </QuatroGrid>
    </main>
  );
}

export default ChallengesList;
